//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsHeader',
  components: {
    NsIcon,
  },
  emits: [
    /**
     * An event that is emitted when the open property is changed with the new value.
     */
    'toggled',
  ],
  props: {
    /**
     * Hides the close button and changes the behavior to close the popup when clicking anywhere on the popup or the grayed out area behind.
     */
    hideCloseButton: {
      default: false,
      type: Boolean,
    },
    /**
     * Determines whether or not the popup is open or closed.
     * (Using v-if not v-show)
     */
    open: {
      default: false,
      type: Boolean,
    },
    /**
     * Changes the styles on the container (not the grayed out area behind)
     */
    containerStyles: {
      default: () => ({
        paddingTop: '30px',
        paddingRight: '20px',
        paddingBottom: '30px',
        paddingLeft: '20px',
      }),
      type: Object,
    },
    /**
     * Displays text in a paragraph tag if populated.
     */
    text: {
      default: '',
      type: String,
    },
  },
  watch: {
    open(newValue) {
      /**
       * An event that is emitted when the open property is changed.
       * @bind newValue The new value of the open property.
       */
      this.$emit('toggled', newValue);
    },
  },
  methods: {
    closeHandler() {
      if (this.hideCloseButton) {
        this.open = false;
      }
    },
  },
};
